import {AfterViewInit, Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {
    MatCardModule,
} from "@angular/material/card";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {DatePipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Router, RouterLink} from "@angular/router";
import {MatButtonModule} from "@angular/material/button";
import * as XLSX from "xlsx";

import {
    MatTableDataSource, MatTableModule
} from "@angular/material/table";
import {MatPaginator, MatPaginatorModule, PageEvent} from "@angular/material/paginator";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatTooltipModule} from "@angular/material/tooltip";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatMenuModule} from "@angular/material/menu";
import {
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerModule,
    MatDatepickerToggle
} from "@angular/material/datepicker";

import {MatCheckbox} from "@angular/material/checkbox";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {ResultService} from "../../../../services/result-service/result.service";
import {UserService} from "../../../../services/user-service/user.service";
import {AnalyseResult, AnalyseService} from "../../../../services/analyse-service/analyse.service";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {DialogService} from "../../../_modal/dialog.service";
import {HandleErrorsService} from "../../../../services/handle-erros/handle.errors.service";
import {ExploitationService} from "../../../../services/exploitation-service/exploitation.service";
import {ClientsService} from "../../../../services/client-service/clients.service";
import {MatNativeDateModule} from "@angular/material/core";
import {ShortUserDTO} from "../../../_models/user.dtos";
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {environment} from "../../../../../environments/environment";
import { finalize } from 'rxjs/operators';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription, MatAccordion } from "@angular/material/expansion";
import { MatIcon } from "@angular/material/icon";

export interface ResultImpDto {
  sampleName: string;               
  analyteName: string;              
  peakArea: number;      
  analyteConcentration: number;              
  calculatedConcentration: number| null; 
  resultStr: string | null;
  technique: 'LCMSMS' | 'GCMSMS';              
  startDate?: string | null; 
  endDate?: string | null;
  //dateMesure?: string | null;
  lq?:number  | null;
  poids?: number | null;
}
interface SampleGroup {
  sampleCode: string;
  analyses: ResultImpDto[];
  expanded?: boolean;
  selected?: boolean; // pour sélectionner tout l'échantillon
}

@Component({
    selector: 'app-in-progress-analyses',
    providers: [ResultService, UserService, AnalyseService, ApiService, Endpoints, DialogService, HandleErrorsService, ExploitationService, ClientsService],
    standalone: true,
    imports: [FormsModule,
    MatDatepickerModule, MatNativeDateModule,
    DatePipe, MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
    MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatDatepicker,
    MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, NgForOf, MatCheckbox, MatProgressSpinner, NgClass, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription, MatAccordion, MatIcon],
    templateUrl: './in-progress-analyses.component.html',
    styleUrl: './in-progress-analyses.component.scss'
})
export class InProgressAnalysesComponent implements OnInit, AfterViewInit {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<AnalyseResult>;
    @ViewChild('viewModal') viewModal: TemplateRef<AnalyseResult>;
    @ViewChild('tableContainer', {static: false}) tableContainer!: ElementRef;



  // Paginator de la sous-table (si côté serveur)
  loadResultsPage(sample: any, event: PageEvent) {
    // Ici, tu appelleras ton backend pour charger les résultats de page `event.pageIndex`
    console.log('Load results page', sample, event);
  }

    searchValue: string = ''
    editForm: FormGroup;
    form: FormGroup;
    selectedAll: boolean = false
    selectedElements: Set<number> = new Set<number>()
    userList: ShortUserDTO[] = []
    analyse?: AnalyseResult
    dataSource = new MatTableDataSource<AnalyseResult>();
    displayedColumns: string[] = [
        'select',
        'ref',
        'sampleCode',
        'parameter',
        'startDate',
        'endDate',
        'lq',
       // 'dateMesure',
        'poids',
        'valide',
        'commentaire',
        'resultatFinale',
        'action'];
    loadingTable: boolean = false;
    loadingCalBtn: boolean = false;
    editedItems: Set<AnalyseResult> = new Set<AnalyseResult>()

    constructor(
        private analyseService: AnalyseService,
        private resultService: ResultService,
        private userService: UserService,
        private handleErrors: HandleErrorsService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private router:Router,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private overlayContainer: OverlayContainer) {
        this.initializeEditForm();
        this.initializeCreateForm()
    }

    ngOnInit(): void {
        this.loadingTable = true;
        this.fetchAnalyseList();  // Appeler la méthode pour l'admin
    }

    
    analyseResults: AnalyseResult[] = [];

calculerMultipleResult() {
    console.log("🚀 Début de la méthode calculerMultipleResult");
    console.log("Éléments sélectionnés :", this.editedItems);

    if (this.editedItems.size === 0) {
        this.dialogService.openDangerDialog("Veuillez sélectionner au moins un résultat.");
        return;
    }

    const dtos: AnalyseResult[] = [...this.editedItems];
    console.log("📦 DTOs envoyés au backend :", dtos);

    this.resultService.calculerMultipleResult1(dtos).subscribe({
        next: (response) => {

    this.ex_event = null;
    this.modalService.dismissAll();

    if (!response.status) {
        this.dialogService.openDangerDialog(response.message || 'Erreur lors de l’import.');
        return;
    }

    this.fetchAnalyseList();

    // 🔥 Vérifier s’il existe des NO INTERCEPT
    if (response.data && response.data.length > 0) {

        console.log("⚠️ NO INTERCEPT détectés :", response.data);

        const noInterceptMsg = response.data.join('\n');

        this.dialogService.openDangerAlert(
            "Import terminé avec NO INTERCEPT détecté(s) :\n\n" + noInterceptMsg
        );

    } else {

        this.dialogService.openSuccessDialog(
            "Les résultats finaux GC ont été mis à jour avec succès"
        );
    }
},
        error: err => {
            console.error("💥 Erreur HTTP :", err);
            this.handleErrors.catchError(err);
        },
        complete: () => {
            console.log("⏹ Fin du traitement – reset des éléments édités");
            this.editedItems.clear();
        }
    });
}

      
    ex_event: any | null = null;
    // Dates pour import Excel
    importStartDate: string | null = null;
    importEndDate: string | null = null;
    //importDateMesure: string | null = null;
    importLQ: number | null = null;
    importPoids: string | null = null;
    private toLocalDateTimeString(date: Date | string | null): string | null {
        if (!date) return null;

        const d = new Date(date);

        const pad = (n: number) => n.toString().padStart(2, '0');

        return (
            d.getFullYear() + '-' +
            pad(d.getMonth() + 1) + '-' +
            pad(d.getDate()) + 'T' +
            pad(d.getHours()) + ':' +
            pad(d.getMinutes()) + ':' +
            pad(d.getSeconds())
        );
        }
importTechnique: 'LCMSMS' | 'GCMSMS' | null = null;
btn_ImportFromExcelFile(): void {

  console.log('📥 Début import Excel LC');

  const target = this.ex_event?.target as DataTransfer;

  if (!this.importTechnique) {
    this.dialogService.openDangerDialog(
      'Veuillez sélectionner la technique (LC)'
    );
    return;
  }

  if (!target?.files || target.files.length !== 1) {
    this.dialogService.openDangerDialog(
      'Veuillez télécharger un seul fichier.'
    );
    return;
  }

  const file = target.files[0];
  const reader = new FileReader();

  reader.onload = (event: ProgressEvent<FileReader>) => {

    try {

      const data = new Uint8Array(event.target?.result as ArrayBuffer);
      const workbook: XLSX.WorkBook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      const jsonData: any[] = XLSX.utils.sheet_to_json(sheet, { defval: null, raw: false });

      const selectedSamples = this.inProgressSamples.filter(s => s.selected);

      if (selectedSamples.length === 0) {
        this.dialogService.openDangerDialog(
          "Veuillez sélectionner au moins un échantillon pour l'import."
        );
        return;
      }

      const dtos: ResultImpDto[] = [];

      // ================================
      // 🔥 NORMALISATION NUMÉRIQUE
      // ================================
      const normalizeNumber = (value: any): number | null => {

        if (!value) return null;

        const str = value.toString().trim();

        if (str === "NA" || str === "NF") return null;

        const normalized = str.replace(",", ".");

        return !isNaN(Number(normalized)) ? Number(normalized) : null;
      };

      jsonData.forEach((row, index) => {

        let sampleName = "";
        let analyteName = "";
        let peakArea: number | null = null;
        let analyteConcentration: number | null = null;
        let calculatedConcentration: number | null = null;
        let resultStr = "";

        const keys = Object.keys(row);

        // =========================================
        // 🔎 CAS CSV MAL STRUCTURÉ (1 COLONNE)
        // =========================================
        if (keys.length === 1) {

          const line = row[keys[0]];

          if (typeof line === 'string') {

            const parts = line.split(',');

            sampleName = parts[0]?.trim() || "";
            analyteName = parts[1]?.trim() || "";

            peakArea = normalizeNumber(parts[2]);
            analyteConcentration = normalizeNumber(parts[3]);

            const rawCalc = parts[4]?.toString()?.trim();

            if (!rawCalc || rawCalc === "NA") {

              calculatedConcentration = null;

            } else {

              const normalizedValue = rawCalc.replace(",", ".");

              if (!isNaN(Number(normalizedValue))) {
                calculatedConcentration = Number(normalizedValue);
              } else {
                calculatedConcentration = null;
                resultStr = rawCalc; // 🔥 NO INTERCEPT / NF
              }
            }

            if (!resultStr) {
              resultStr = parts[5]?.toString()?.trim() || "";
            }
          }

        } else {

          // =========================================
          // ✅ CAS EXCEL NORMAL
          // =========================================

          sampleName = row["Sample Name"]?.toString().trim() || "";
          analyteName = row["Analyte Name"]?.toString().trim() || "";

          peakArea = normalizeNumber(row["Analyte Peak Area"]);
          analyteConcentration = normalizeNumber(row["Analyte Concentration"]);

          const rawCalc = row["Calculated Concentration"]?.toString()?.trim();

          if (!rawCalc || rawCalc === "NA") {

            calculatedConcentration = null;

          } else {

            const normalizedValue = rawCalc.replace(",", ".");

            if (!isNaN(Number(normalizedValue))) {
              calculatedConcentration = Number(normalizedValue);
            } else {
              calculatedConcentration = null;
              resultStr = rawCalc; // 🔥 NO INTERCEPT
            }
          }

          // 🔥 Si toujours pas de texte → prendre colonne Result
          if (!resultStr) {
            const rawResult = row["Result"]?.toString()?.trim();
            if (rawResult && rawResult !== "NA") {
              resultStr = rawResult;
            }
          }
        }

        // 🔎 Match sample sélectionné
        const matchingSample = selectedSamples.find(
          s =>
            s.referenceInterne?.trim().toLowerCase() === sampleName.toLowerCase()
            || s.sampleCode?.trim().toLowerCase() === sampleName.toLowerCase()
        );

        if (!matchingSample) return;

        const poids = matchingSample.poids ?? null;

        dtos.push({
          sampleName,
          analyteName,
          peakArea: peakArea ?? 0,
          analyteConcentration: analyteConcentration ?? 0,
          calculatedConcentration,
          resultStr,
          technique: this.importTechnique!,
          startDate: this.toLocalDateTimeString(this.importStartDate),
          endDate: this.toLocalDateTimeString(this.importEndDate),
          lq: this.importLQ,
          poids
        });

      });

      if (dtos.length === 0) {
        this.dialogService.openDangerDialog(
          "Aucun échantillon sélectionné trouvé dans le fichier Excel."
        );
        return;
      }

      // =========================================
      // 🔥 ENVOI BACKEND + GESTION NO INTERCEPT
      // =========================================

      this.resultService.updateResultfromExcel1(dtos).subscribe({

        next: (response) => {

          this.ex_event = null;
          this.modalService.dismissAll();

          if (!response.status) {
            this.dialogService.openDangerDialog(
              response.message || "Erreur lors de l’import."
            );
            return;
          }

          this.fetchAnalyseList();

          // 🔥 EXACTEMENT COMME GC
          if (response.data && response.data.length > 0) {

            const noInterceptMsg = response.data.join('\n');

            this.dialogService.openDangerAlert(noInterceptMsg);

          } else {

            this.dialogService.openSuccessDialog(
              "Les résultats finaux LC ont été mis à jour avec succès"
            );
          }
        },

        error: (err) => {

          this.ex_event = null;
          this.modalService.dismissAll();

          this.dialogService.openDangerDialog(
            err?.error?.message || "Erreur lors de l’import."
          );
        }
      });

    } catch (error) {

      console.error('❌ Erreur traitement fichier Excel :', error);

      this.dialogService.openDangerDialog(
        "Erreur lors du traitement du fichier Excel."
      );
    }
  };

  reader.onerror = () => {
    this.dialogService.openDangerDialog(
      "Erreur lors de la lecture du fichier."
    );
  };

  reader.readAsArrayBuffer(file);
}
  
importExcel() {
  console.log("📥 Début de la fonction importExcel()");
  console.log("🧪 Technique sélectionnée :", this.importTechnique);

  if (!this.importTechnique) {
    console.warn("⚠️ Aucune technique sélectionnée !");
    this.dialogService.openDangerDialog("Veuillez sélectionner la technique (LCMSMS ou GCMSMS)");
    return;
  }

  if (this.importTechnique === 'LCMSMS') {
    console.log("➡️ Import Excel pour LCMSMS détecté, appel de btn_ImportFromExcelFile()");
    this.btn_ImportFromExcelFile();
  } 
  else if (this.importTechnique === 'GCMSMS') {
    console.log("➡️ Import Excel pour GCMSMS détecté, appel de btn_ImportFromExcelFileGC()");
    this.btn_ImportFromExcelFileGC();
  } 
  else {
    console.error("❌ Technique inconnue :", this.importTechnique);
    this.dialogService.openDangerDialog("Technique inconnue sélectionnée !");
  }

  console.log("📤 importExcel() terminé");
}


btn_ImportFromExcelFileGC() {

    console.log("📥 Début import Excel GC");

    const target: DataTransfer = <DataTransfer>(this.ex_event.target);

    if (!this.importTechnique) {
        this.dialogService.openDangerDialog("Veuillez sélectionner la technique (GC)");
        return;
    }

    if (!target || target.files.length !== 1) {
        this.dialogService.openDangerDialog("Veuillez télécharger un seul fichier.");
        return;
    }

    const file = target.files[0];
    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {

        const binaryData = e.target.result;
        const workbook: XLSX.WorkBook = XLSX.read(binaryData, { type: 'binary' });

        const dtos: ResultImpDto[] = [];

        const selectedSamples = this.inProgressSamples.filter(s => s.selected);

        if (selectedSamples.length === 0) {
            this.dialogService.openDangerDialog("Veuillez sélectionner au moins un échantillon pour l'import.");
            return;
        }

        workbook.SheetNames.forEach(sheetName => {

            const sheet: XLSX.WorkSheet = workbook.Sheets[sheetName];

            const jsonData: any[] = XLSX.utils.sheet_to_json(sheet, {
                defval: null,
                range: 5,
                header: [
                    'filename', 'sampleType', 'sampleName', 'integType',
                    'area', 'istdArea', 'area2',
                    'amount', 'amount2',
                    'percentDiff', 'percentRSD',
                    'peakStatus', 'level', 'units', 'rt', 'sampleId'
                ]
            });

            jsonData.forEach((row) => {

                if (!row.sampleName) return;

                const matchingSample = selectedSamples.find(
                    s =>
                        s.referenceInterne?.trim().toLowerCase() === row.sampleName?.toString().trim().toLowerCase()
                        || s.sampleCode?.trim().toLowerCase() === row.sampleName?.toString().trim().toLowerCase()
                );

                if (!matchingSample) return;

                const poids = matchingSample.poids ?? null;

                // ================================
                // 🔥 NORMALISATION DES VALEURS
                // ================================

                const normalizeNumber = (value: any): number | null => {

                    if (!value) return null;

                    const str = value.toString().trim();

                    if (str === "NA" || str === "NF") return null;

                    const normalized = str.replace(",", ".");

                    return !isNaN(Number(normalized)) ? Number(normalized) : null;
                };

                // ================================
                // 🔥 GESTION CALCULATED AMOUNT
                // ================================

                let calculatedConcentration: number | null = null;
                let resultStr: string = "";

                const rawAmount2 = row.amount2?.toString()?.trim();

                if (!rawAmount2 || rawAmount2 === "NA") {

                    calculatedConcentration = null;

                } else {

                    const normalizedValue = rawAmount2.replace(",", ".");

                    if (!isNaN(Number(normalizedValue))) {

                        calculatedConcentration = Number(normalizedValue);

                    } else {

                        // NF / NO INTERCEPT
                        calculatedConcentration = null;
                        resultStr = rawAmount2;
                    }
                }

                // Si aucun texte analytique trouvé → prendre Peak Status
                if (!resultStr) {
                    const peakStatus = row.peakStatus?.toString()?.trim();
                    if (peakStatus && peakStatus !== "NA") {
                        resultStr = peakStatus;
                    }
                }

                // ================================
                // 🔥 CONSTRUCTION DTO
                // ================================

                const dto: ResultImpDto = {

                    sampleName: row.sampleName?.toString()?.trim(),

                    analyteName: sheetName,

                    peakArea: normalizeNumber(row.area) ?? 0,

                    analyteConcentration: normalizeNumber(row.amount) ?? 0,

                    calculatedConcentration: calculatedConcentration,

                    resultStr: resultStr,

                    technique: this.importTechnique!,

                    startDate: this.toLocalDateTimeString(this.importStartDate),

                    lq: this.importLQ,

                    poids: poids,

                    endDate: this.toLocalDateTimeString(this.importEndDate),
                };

                dtos.push(dto);
            });
        });

        if (dtos.length === 0) {
            this.dialogService.openDangerDialog("Aucun échantillon sélectionné trouvé dans le fichier Excel.");
            return;
        }

        this.resultService.updateResultfromExcel1(dtos).subscribe({
            next: (response) => {

    this.ex_event = null;
    this.modalService.dismissAll();

    if (!response.status) {
        this.dialogService.openDangerDialog(response.message || 'Erreur lors de l’import.');
        return;
    }

    this.fetchAnalyseList();

    // 🔥 Vérifier s’il existe des NO INTERCEPT
    if (response.data && response.data.length > 0) {

        console.log("⚠️ NO INTERCEPT détectés :", response.data);

        const noInterceptMsg = response.data.join('\n');

        this.dialogService.openDangerAlert(
            noInterceptMsg
        );

    } else {

        this.dialogService.openSuccessDialog(
            "Les résultats finaux GC ont été mis à jour avec succès"
        );
    }
},
            error: err => {

                this.ex_event = null;
                this.modalService.dismissAll();

                this.dialogService.openDangerDialog(
                    err.error?.message || 'Erreur lors de l’import.'
                );
            }
        });
    };

    reader.onerror = () => {
        this.dialogService.openDangerDialog("Erreur lors de la lecture du fichier.");
    };

    reader.readAsBinaryString(file);
}
openImportModal(importModal: any) {
    console.log('🚀 Chargement des analyses en cours...');
  
    this.analyseService.getAnalyseResultsByStatut('EN_COURS').subscribe({
      next: (res: any[]) => {
  
        if (!res || res.length === 0) {
          console.warn('⚠️ Aucune analyse en cours trouvée.');
          this.inProgressSamples = [];
          this.modalService.open(importModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
          return;
        }
  
        // ===== Regrouper par référence interne (sampleAnalyseRef) =====
        const grouped = new Map<string, any>();
        res.forEach(a => {
          const referenceInterne = a.sampleAnalyseRef; // 🔑 référence interne
          if (!grouped.has(referenceInterne)) {
            grouped.set(referenceInterne, {
              sampleCode: a.sampleCode,
              referenceInterne: referenceInterne,
              selected: false,
              poids: null, // poids spécifique pour ce sample
              analyses: [] // liste des analyses pour ce sample
            });
          }
          grouped.get(referenceInterne).analyses.push(a);
        });
  
        // Convertir en tableau
        this.inProgressSamples = Array.from(grouped.values());
  
        console.log(`📦 ${this.inProgressSamples.length} échantillons uniques chargés :`, this.inProgressSamples);
  
        this.modalService.open(importModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
      },
      error: (err) => {
        console.error('❌ Erreur lors du chargement des analyses :', err);
        this.inProgressSamples = [];
      }
    });
  }
  
    event: any | null = null;
fetchAnalyseList(): void {
  console.log("🚀 fetchAnalyseList called");

  const username = sessionStorage.getItem('user_username');
  console.log("👤 Username récupéré :", username);

  if (!username) {
    console.error("❌ Aucun utilisateur connecté");
    return;
  }

  this.loadingTable = true; // ⏳ START LOADING

  this.analyseService.getAnalyseResultsByStatut('EN_COURS')
    .pipe(
      finalize(() => {
        this.loadingTable = false; // ✅ STOP LOADING (success أو error)
        console.log("⏹ Loading terminé");
      })
    )
    .subscribe({
      next: (data) => {
        console.log('📥 Données reçues (EN_COURS) :', data);
        this.dataSource.data = data ?? [];
      },
      error: (err) => {
        console.error('❌ Erreur chargement EN_COURS :', err);
      }
    });
}

    fetchUserAnalyses() {
        const username = sessionStorage.getItem('user_username');
        console.log("Utilisateur connecté : ", username);
    
        if (!username) {
          console.error("Aucun utilisateur connecté");
          return;
        }
    
        this.analyseService.getMyAnalyses(username).subscribe({
          next: response => {
            if (response.status) {
              this.dataSource.data = response.data;
              console.log("Données des analyses pour l'utilisateur connecté : ", this.dataSource.data);
            } else {
              console.log("Accès non autorisé");
              this.router.navigate(['/not-authorized']);
            }
            this.loadingTable = true;
          },
          error: err => {
            console.error("Erreur: ", err);
            this.handleErrors.catchError(err);
            this.loadingTable = false;
          },
          complete: () => {
            this.loadingTable = false;
            console.log("Requête terminée");
          }
        });
      }
    

    fetchUsers() {
        this.userService.getUsers().subscribe({
            next: res => {
                if (res.status) {
                    this.userList = res.data
                }
            }
        })
    }

    ngAfterViewInit() {
        this.initializePaginatorAndSort();
    }

    initializePaginatorAndSort() {
        this.dataSource.filter = this.searchValue
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'asc';
        const overlayContainerElement = this.overlayContainer.getContainerElement();
        overlayContainerElement.style.zIndex = '2000';
    }

    initializeEditForm() {
        this.editForm = this.fb.group({
            id: ['', Validators.required],
            refAnalyse: ['', Validators.required],
            startDate: ['', Validators.required],
            endDate: ['', Validators.required],
            //dateMesure: ['', Validators.required],
            creationDate: ['', Validators.required],
            status: [null, Validators.required],
            commentaire: ['', Validators.required],
            sampleId: [null, Validators.required],
            sampleCode: ['', Validators.required],
            parameterId: [null, Validators.required],
            parameterName: ['',],
            userId: [null, Validators.required],
            resultId: [null, Validators.required],
            poids: ['', Validators.required],
            resultatBrute: ['', Validators.required],
            resultatFinale: ['', Validators.required],
            userName: ['',],
        });

    }

    initializeCreateForm() {
        this.form = this.fb.group({
            userId: ['', Validators.required]
        });
    }
    openEditModal(element: AnalyseResult) {
        this.editForm.patchValue(element);
        console.log(element)
        this.modalService.open(this.editModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    }

    openModal(content: any) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'sm'})
    }

    openViewModel(element: AnalyseResult) {
        this.analyse = element
        this.modalService.open(this.viewModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    }

    updateTableRow(analyseDTO: AnalyseResult) {
        const index = this.dataSource.data.findIndex(item => item.id === analyseDTO.id);
        if (index !== -1) {
            this.dataSource.data[index] = analyseDTO;
            this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
        }
    }

    confirmDelete(id: number) {
        this.dialogService.open('Etes-vous sûr de vouloir supprimer cet élément ?', environment.warning_message_type, 'danger', environment.warning_icon, true)
            .then((result: any) => {
                if (result) {
                    this.deleteAnalyse(id);
                }
            });
    }

    private deleteAnalyse(id: number) {
        this.analyseService.delete(id).subscribe({
            next: response => {
                if (response.status) {
                    this.dataSource.data = this.dataSource.data.filter(item => item.id != id)
                    this.dialogService.openSuceessAlert(response.message);

                } else {
                    this.dialogService.open(response.message, environment.error_message_type, 'danger', environment.error_icon).finally();

                }
            }, error: err => this.handleErrors.catchError(err),
        })
    }

    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filter = this.searchValue;
    }

    updateAnalyse(element: AnalyseResult) {
        this.analyseService.updateE(element).subscribe({
            next: response => {
                if (response.status) {
                    this.updateTableRow(response.data)
                    this.modalService.dismissAll();
                    this.dialogService.openSuccessDialog(response.message);
                } else {
                    this.dialogService.openDangerDialog(response.message);
                }
            },
            error: err => this.handleErrors.catchError(err),
            complete: () => {
                this.initializePaginatorAndSort();
            }
        });
    }

    handleChecked(element: AnalyseResult) {
        if (this.selectedElements.has(element.id)) {
            this.selectedElements.delete(element.id)
        } else {
            this.selectedElements.add(element.id)
        }
    }

    handleSelectAll() {
        this.selectedAll = !this.selectedAll
        if (this.selectedAll)
            this.selectedElements = new Set<number>(this.dataSource.data.map(element => element.id))
        else
            this.selectedElements = new Set<number>()
    }

    navigateInputs(event: KeyboardEvent, index: number, column: string): void {
        const columns = ['ref', 'sampleCode', 'parameter', 'status','lq', 'startDate', 'endDate', 'poids', 'resultatBrute', 'resultatFinale', 'commentaire']; // Add all columns with inputs here
        const columnIndex = columns.indexOf(column);

        switch (event.key) {
            case 'Enter':
            case 'ArrowDown':
                const nextRow = document.getElementById(`${column}${index + 1}`);
                if (nextRow) nextRow.focus();
                event.preventDefault();
                break;

            case 'ArrowUp':
                // Move to the input above, if it exists
                const previousRow = document.getElementById(`${column}${index - 1}`);
                if (previousRow) previousRow.focus();
                event.preventDefault();
                break;

            case 'ArrowRight':
                if (columnIndex < columns.length - 1) {
                    // Move to the next column in the same row
                    const nextColumn = document.getElementById(`${columns[columnIndex + 1]}${index}`);
                    if (nextColumn) nextColumn.focus();
                    event.preventDefault();
                }
                break;

            case 'ArrowLeft':
                if (columnIndex > 0) {
                    // Move to the previous column in the same row
                    const previousColumn = document.getElementById(`${columns[columnIndex - 1]}${index}`);
                    if (previousColumn) previousColumn.focus();
                    event.preventDefault();
                }
                break;
        }
    }

   /* calculerMultipleResult() {
        if (this.editedItems.size == 0) {
            this.dialogService.openDangerDialog("Veuillez sélectionner au moins un element.")
            return
        }
        this.loadingCalBtn = true
        const dtos: AnalyseDTO[] = [...this.editedItems]
        setTimeout(()=>  this.analyseService.calculerMultipleResult(dtos).subscribe({
            next: response => {
                if (response.status) {
                    this.dataSource.data = response.data
                    this.modalService.dismissAll()
                    this.dialogService.openSuccessDialog("Les résultats finaux ont été mis à jour avec succès.")
                    this.fetchAnalyseList();
                }
            },
            error: err => {
                this.handleErrors.catchError(err)
                this.editedItems = new Set<AnalyseDTO>()
                this.loadingCalBtn = false
            },
            complete: () => {
                this.editedItems = new Set<AnalyseDTO>()
                this.loadingCalBtn = false
            }
        }),1200)

    }*/

    addResult(element: AnalyseResult) {
        this.editedItems.add(element)
        console.log('items:',this.editedItems)
    }

    // Liste des échantillons en cours
inProgressSamples: any[] = [];

// Select all
allSelected: boolean = false;

toggleSelectAll(event: any) {
  this.allSelected = event.target.checked;

  if (!this.inProgressSamples || this.inProgressSamples.length === 0) {
    console.warn("⚠️ Aucun échantillon à sélectionner !");
    return;
  }

  this.inProgressSamples.forEach(s => s.selected = this.allSelected);
  console.log("✔️ Sélection globale :", this.allSelected);
}


}

